// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".color-variataion{border:1px solid #9d9d9d;border-radius:8px;cursor:pointer;font-size:14px;font-weight:700;padding:8px;width:-moz-fit-content;width:fit-content}.selected{border:2px solid #fb9013;color:#000;font-weight:700}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
